// Mesaj yazma alanı — hasta konuşması ve "Yeni kişiler" konusu ortak kullanır.

import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { ActionButton, FormTextField } from "../../components/atoms";
import { COLORS, TYPO } from "../../styles/uiConstants";
import { MAX_MESSAGE_LENGTH } from "./messageFormat";

/**
 * @param {(text: string) => Promise<boolean>} onSend - başarılıysa true (taslak temizlenir)
 * @param {boolean} sending
 * @param {boolean} disabled - yazma kapalı (yetki / bağlantı / 24 saat penceresi)
 * @param {string} [note] - alanın üstünde açıklama
 * @param {React.ReactNode} [top] - not satırının yanında/üstünde ek içerik (kanal seçici)
 * @param {React.ReactNode} [extra] - notun altında ek aksiyon (ör. bildirim gönder)
 * @param {string} resetKey - değişince taslak temizlenir (konu değişimi)
 * @param {object} palette
 */
export default function MessageComposer({ onSend, sending, disabled, note, top, extra, resetKey, palette }) {
  const [draft, setDraft] = useState("");
  useEffect(() => {
    setDraft("");
  }, [resetKey]);

  const trimmed = draft.trim();
  const blocked = disabled || sending;
  const submit = async () => {
    if (!trimmed || blocked) return;
    const ok = await onSend(trimmed);
    if (ok) setDraft("");
  };

  return (
    <Box sx={{ borderTop: `1px solid ${COLORS.slate200}`, px: { xs: 1.5, md: 3 }, py: 1.5, flexShrink: 0 }}>
      {top ? <Box sx={{ mb: 1 }}>{top}</Box> : null}
      {note ? <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate500, mb: 1 }}>{note}</Typography> : null}
      {extra ? <Box sx={{ mb: 1 }}>{extra}</Box> : null}
      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1.25 }}>
        <FormTextField
          palette={palette}
          fullWidth
          multiline
          maxRows={5}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
              e.preventDefault();
              submit();
            }
          }}
          placeholder={disabled ? "Mesaj gönderilemez" : "Mesaj yazın… (Shift+Enter yeni satır)"}
          disabled={disabled}
          inputProps={{ maxLength: MAX_MESSAGE_LENGTH, "aria-label": "Mesaj" }}
          helperText={draft.length > MAX_MESSAGE_LENGTH - 200 ? `${draft.length}/${MAX_MESSAGE_LENGTH}` : undefined}
        />
        <ActionButton
          variant="send"
          palette={palette}
          loading={sending}
          disabled={!trimmed || blocked}
          onClick={submit}
          size="medium"
          sx={{ flexShrink: 0, minHeight: 44 }}
        />
      </Box>
    </Box>
  );
}
